import React, { useEffect, useState, useContext } from 'react';
import { message, Form } from 'antd';
import { CommonCloudFirestore } from '../../services/CommonCloudFirestore';
import { ModalContext } from '../../../shared/context/ModalContext';
import { DOCUMENT_SECTION, DOCUMENT_SECTION_DETAIL, LISTENER_SECTIONS } from '../../../shared/types/firestoreType';

import global from '../../../shared/utility/global';

import Header from './Header';
import Items from './Items';
import Filter from './Filter';
import FormModal from './FormModal';
import FormDetailModal from './FormDetailModal/Index';

import './styles.css'

export default function Index(_) {
    const modal = useContext(ModalContext);
    const sectionFirestore = new CommonCloudFirestore(DOCUMENT_SECTION);
    const sectionDetailFirestore = new CommonCloudFirestore(DOCUMENT_SECTION_DETAIL);

    const [filterForm] = Form.useForm();
    const [sections, setSections] = useState([]);
    const [sectionDetails, setSectionDetails] = useState([]);
    const [filteredSections, setFilteredSections] = useState([]);
    const [loading, setLoading] = useState(false);

    const [openForm, setOpenForm] = useState(false);
    const [id, setId] = useState('');

    const [openFormDetail, setOpenFormDetail] = useState(false);
    const [detailId, setDetailId] = useState('');

    const [dragId, setDragId] = useState();
    const [dragParentId, setDragParentId] = useState();

    useEffect(() => {
        onLoad();
    }, []);

    useEffect(() => {
        setFilteredSections(sections);
    }, [sections]);

    const onSearch = () => {
        var keyword = filterForm.getFieldsValue().keyword;
        const filtered = sections.filter(item => {
            return global.formatSearch(item.title).match(global.formatSearch(keyword));
        });
        setFilteredSections(filtered);
    };

    const onLoad = async () => {
        setLoading(true);
        let sections = await sectionFirestore.getDocuments();
        let sectionDetails = await sectionDetailFirestore.getDocuments();
        let sectionDetailsOrder = [];

        sections.forEach(item => {
            let filteredOrder = sectionDetails.filter(m => m.sectionId === item.id).sort(global.orderBy('index'));
            item.items = filteredOrder;
            filteredOrder.map(m => ({ ...m })).forEach(element => {
                sectionDetailsOrder.push(element)
            });
        });

        setSections(sections.sort(global.orderBy('index')));
        setSectionDetails(sectionDetailsOrder);
        setLoading(false);
    };

    const onAdd = (event, item) => {
        event.stopPropagation();
        setId(item.id);
        setDetailId('');
        setOpenFormDetail(true);
    };

    const onEdit = (event, item) => {
        event.stopPropagation();
        setId(item.id);
        setOpenForm(true);
    };

    const onDelete = async (event, item) => {
        event.stopPropagation();
        modal.confirm(`¿Está seguro de continuar?`, async () => {
            var result = await sectionFirestore.deleteDocument(item.id, [LISTENER_SECTIONS]);

            if (result)
                message.success('Proceso realizado con éxito.');
            else
                message.error('Ocurrió un error inesperado.');

            onLoad();
        });
    };

    /******************************************************************************************************/

    const onEditDetail = (item) => {
        setId(item.sectionId);
        setDetailId(item.id);
        setOpenFormDetail(true);
    };

    const onDeleteDetail = async (item) => {
        modal.confirm(`¿Está seguro de continuar?`, async () => {
            var result = await sectionDetailFirestore.deleteDocument(item.id, [LISTENER_SECTIONS]);

            if (result)
                message.success('Proceso realizado con éxito.');
            else
                message.error('Ocurrió un error inesperado.');

            onLoad();
        });
    };

    /******************************************************************************************************/

    const onDragStart = (ev) => {
        setDragId(ev.currentTarget.id.split('|')[0]);
        setDragParentId(ev.currentTarget.id.split('|')[1]);

        var coverQuerySelectorAll = document.querySelectorAll(`.class${ev.currentTarget.id.split('|')[1]} > .catalog-card-content`);
        coverQuerySelectorAll.forEach(function (item) {
            item.classList.add('catalog-card-pointer-events');
        });
    };

    const onDragEnter = (ev) => {
        if ([...ev.currentTarget.classList].filter(m => m === `class${dragParentId}`).length > 0)
            ev.currentTarget.classList.add('over');
    };

    const onDragLeave = (ev) => {
        if ([...ev.currentTarget.classList].filter(m => m === `class${dragParentId}`).length > 0)
            ev.currentTarget.classList.remove('over');
    };

    const onDrop = async (ev) => {
        let currentId = ev.currentTarget.id.split('|')[0];
        let parentId = ev.currentTarget.id.split('|')[1];

        if (currentId === dragId)
            return;

        if (parentId !== dragParentId)
            return;

        const fetchIndex = (source, id) => {
            var result = 0;
            for (let index = 0; index < source.length; index++) {
                if (source[index].id === id) {
                    result = index;
                    break;
                }
            }
            return result;
        };

        setLoading(true);

        var orderItems = [];
        const filtered = sectionDetails.filter(m => m.sectionId === dragParentId).map(m => ({ ...m }));
        const dragIndex = fetchIndex(filtered, dragId);
        const dropIndex = fetchIndex(filtered, currentId);

        const reorganizedItems = filtered.map((item, index) => {
            if (item.id === dragId) {
                item.index = dropIndex;
                orderItems.push({ id: item.id, index: dropIndex });
            }
            else if (item.id === currentId) {
                item.index = dragIndex;
                orderItems.push({ id: item.id, index: dragIndex });
            }
            else {
                item.index = index;
            }

            return item;
        }).sort(global.orderBy('index'));

        var sectionDetailsOrder = [];
        var newSections = sections.map(m => ({ ...m }));

        newSections.forEach(item => {
            if (item.id === dragParentId)
                item.items = reorganizedItems;

            item.items.map(m => ({ ...m })).forEach(element => {
                sectionDetailsOrder.push(element)
            });
        });

        /******************* SAVE  ***************/
        var response = await sectionDetailFirestore.updatePositions(orderItems, [LISTENER_SECTIONS]);
        if (response) {
            setSections(newSections);
            setSectionDetails(sectionDetailsOrder);
            message.success("Orden cambiado correctamente.");
        }
        else {
            message.error("Ocurrió un error al cambiar el orden, vuelvalo a intentar mas tarde.");
        }

        setLoading(false);
    };

    const onDragEnd = (ev) => {
        var firstSelectorAll = document.querySelectorAll(`.class${dragParentId} > .catalog-card-content`);
        firstSelectorAll.forEach(item => {
            item.classList.remove('catalog-card-pointer-events');
        });

        var secondSelectorAll = document.querySelectorAll('.content-card');
        secondSelectorAll.forEach(item => {
            item.classList.remove('over');
        });
    };

    return (
        <>
            <Header
                onSearch={onSearch}
                onNew={() => {
                    setId('');
                    setOpenForm(true);
                }}
            />
            <Filter
                form={filterForm}
                onSearch={onSearch}
            />
            <Items
                sections={filteredSections}
                loading={loading}
                onAdd={onAdd}
                onEdit={onEdit}
                onDelete={onDelete}
                onEditDetail={onEditDetail}
                onDeleteDetail={onDeleteDetail}
                onDragStart={onDragStart}
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
                onDragEnd={onDragEnd}
            />
            <FormModal
                id={id}
                open={openForm}
                onLoad={onLoad}
                onCancel={() => {
                    setId('');
                    setOpenForm(false);
                }}
            />
            <FormDetailModal
                id={detailId}
                parentId={id}
                open={openFormDetail}
                onLoad={onLoad}
                onCancel={() => {
                    setDetailId('');
                    setOpenFormDetail(false);
                }}
            />
        </>
    )
}